import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { reportsAPI } from '../../services/api';

export const fetchReports = createAsyncThunk('reports/fetch', async (params, { rejectWithValue }) => {
  try {
    const response = await reportsAPI.getContentReports(params);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch reports');
  }
});

const reportsSlice = createSlice({
  name: 'reports',
  initialState: { data: null, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReports.pending, (state) => { state.loading = true; })
      .addCase(fetchReports.fulfilled, (state, action) => { state.loading = false; state.data = action.payload; })
      .addCase(fetchReports.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export default reportsSlice.reducer;
